<template>
  <li class="v-tab nav-item" role="presentation">
    <button :id="id + '-tab'"
            class="nav-link text-primary fw-semi py-8 mb-16"
            data-bs-toggle="pill"
            type="button"
            role="tab"
            :data-bs-target="'#' + id"
            :aria-controls="id"
            :aria-selected="active"
            :class="{'active': active}"
            @click="$emit('click')"
    >
      <slot></slot>
    </button>
  </li>
</template>

<script>
export default {
  name: 'VTab',
  emits: ['click'],
  data() {
    return {}
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    active: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
